import { Box } from 'braid-design-system';
import React from 'react';

import { DesktopLargeHeader } from './DesktopLargeHeader';
import { DesktopSmallHeader } from './DesktopSmallHeader';
import { MobileHeader } from './MobileHeader';
import {
  deviceSectionTestIds,
  navigationHeaderRootId,
} from './utils/generalUtils';
import type { RenderVariant } from './utils/typeUtils';

import * as styles from './NavigationHeader.css';

interface NavigationHeaderProps {
  variant: RenderVariant;
  baseUrl: string;
  advertiserCentreUrl: string;
}

export const NavigationHeader = ({
  variant,
  baseUrl,
  advertiserCentreUrl,
}: NavigationHeaderProps) => (
  <Box
    className={styles.navigationHeader}
    id={navigationHeaderRootId}
    data={{
      testid: 'navigation-header-root',
      ['navigation-header-variant']: variant,
    }}
  >
    <Box
      data={{ testid: deviceSectionTestIds.mobile }}
      className={styles.mobileHeaderBreakpointContainer}
    >
      <MobileHeader
        variant={variant}
        baseUrl={baseUrl}
        advertiserCentreUrl={advertiserCentreUrl}
      />
    </Box>

    <Box
      data={{ testid: deviceSectionTestIds.desktopSmall }}
      className={styles.desktopSmallHeaderBreakpointContainer}
    >
      <DesktopSmallHeader
        variant={variant}
        baseUrl={baseUrl}
        advertiserCentreUrl={advertiserCentreUrl}
      />
    </Box>

    <Box
      data={{ testid: deviceSectionTestIds.desktopLarge }}
      className={styles.desktopLargeHeaderBreakpointContainer}
    >
      <DesktopLargeHeader
        variant={variant}
        baseUrl={baseUrl}
        advertiserCentreUrl={advertiserCentreUrl}
      />
    </Box>
  </Box>
);
